import React from 'react'

import ExternalLink from '@/components/misc/ExternalLink'

export interface Props {
  query: string | null
  className?: string
}

const FcaSearchLink: React.FC<Props> = ({ query, className }) => {
  if (query === null) {
    return null
  }

  return (
    <ExternalLink
      className={className}
      href={`https://register.fca.org.uk/s/search?q=${query}&type=Companies`}
    >
      FRN: {query}
    </ExternalLink>
  )
}

export default FcaSearchLink
